import axios from 'axios';
import { useUserStore } from '../store/useUserStore';
import globalMessage from './messageInstance';

// 根据当前网页地址动态设置 baseURL
const getBaseURL = () => {
  const currentHost = window.location.hostname;

  if (currentHost === 'admin-test.doyourfootball.com') {
    //测试环境地址
    return 'https://app-test.doyourfootball.com/api';
  } else if (currentHost === 'admin-preprod.doyourfootball.com') {
    //预生产环境地址
    return 'https://admin-preprod.doyourfootball.com/api';
  } else if (currentHost === 'admin.doyourfootball.com') {
    //生产环境地址
    return 'https://admin.doyourfootball.com/api';
  }

  //本地开发环境地址
  return import.meta.env.VITE_API_BASE_URL;
};

const service = axios.create({
  baseURL: getBaseURL(),
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    const token = useUserStore.getState().token;
    if (token) {
      config.headers.Authorization = `${token}`;
    }
    config.headers.timezone = new Intl.DateTimeFormat().resolvedOptions().timeZone;
    config.headers['Client-Version'] = '1.0.0';
    config.headers['Client-Category'] = 'admin';
    config.headers['Client-Type'] = '4';
    config.headers['Language'] = 'en';
    // TODO: 补充逻辑
    return config;
  },
  (error) => Promise.reject(error)
);

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    const contentType = response.headers['content-type'];
    if (contentType && (contentType.includes('application/vnd.openxmlformats-officedocument') || response.data instanceof Blob || response.data instanceof ArrayBuffer)) {
      return response.data;
    }
    if (response.status === 200) {
      if (response.data.code === 200) {
        return response.data;
      } else if (response.data.code === 401) {
        useUserStore.getState().clearAuth();
        window.location.href = '/login';
      } else {
        if (response.config.url === '/whiteList/export') {
          return response.data;
        } else {
          globalMessage.error(response.data.message || 'request failed');
          return Promise.reject(response.data);
        }
      }
    }
    // return response;
  },
  (error) => {
    console.log('请求错误:', error);
    // 全局错误处理：401 登出、其它提示等
    if (error.response?.status === 401) {
      useUserStore.getState().clearAuth();
      window.location.href = '/login';
    } else if (error.response?.status >= 500) {
      // 处理500+服务器错误
      const errorMessage = error.response?.data?.message || `server error (${error.response.status})`;
      globalMessage.error(errorMessage);
    } else if (error.response?.status >= 400) {
      // 处理400+客户端错误
      const errorMessage = error.response?.data?.message || `client error (${error.response.status})`;
      globalMessage.error(errorMessage);
    } else {
      // 处理网络错误等其他错误
      const errorMessage = error.message || 'network request failed';
      globalMessage.error(errorMessage);
    }
    return Promise.reject(error);
  }
);

export default service;
